module.exports = __webpack_public_path__ + "images/arrow-line-s@2x-d86ee93776d835f4fb8e239d9361b618.png";